import React, { useEffect } from 'react'

const CDP = () => {
  const handleLoad = () => {
    window.SalesforceInteractions.init({
      consents: [
        {
          provider: 'OneTrust',
          purpose: window.SalesforceInteractions.ConsentPurpose.Tracking,
          status: window.SalesforceInteractions.ConsentStatus.OptIn,
        },
      ],
    })
  }
  useEffect(() => {
    if (window && window.SalesforceInteractions) {
      window.SalesforceInteractions.init({
        consents: [
          {
            provider: 'OneTrust',
            purpose: window.SalesforceInteractions.ConsentPurpose.Tracking,
            status: window.SalesforceInteractions.ConsentStatus.OptIn,
          },
        ],
      })
    }
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        handleLoad()
      }
    })
    return () => {
      window.removeEventListener('visibilitychange', handleLoad)
    }
  })

  useEffect(() => {
    if (window) {
      const urls = JSON.parse(window.localStorage.getItem('paths'))

      if (urls) {
        const paths = urls
        paths.push(window.location.href)
        window.localStorage.setItem('paths', JSON.stringify(paths))
      } else {
        const paths = []
        paths.push(window.location.href)
        window.localStorage.setItem('paths', JSON.stringify(paths))
      }
    }
  }, [])

  return (
    <div />
  )
}
export default CDP
